import { UserRole, type UserWithProfile } from '@klaro7/shared-types';

/** Standalone route that hosts the blocking "check your email" step. */
export const EMAIL_VERIFICATION_PATH = '/conferma-email';

/**
 * Same roles as the phone gate — see phoneGate.ts. Admins are never gated.
 */
const GATED_ROLES: UserRole[] = [UserRole.USER, UserRole.PROFESSIONAL];

/**
 * True when the logged-in account must confirm its email (doppio opt-in,
 * 2026-08-27) before it can reach the phone-OTP step or any authenticated
 * surface. Comes BEFORE needsPhoneVerification in ProtectedRoute: the phone
 * OTP is not even requestable server-side until the email is confirmed (see
 * phone-verification.service.ts → requestCode).
 */
export function needsEmailVerification(user: UserWithProfile | null | undefined): boolean {
  if (!user) return false;
  if (!GATED_ROLES.includes(user.role)) return false;
  return user.profile?.emailVerified !== true;
}
